import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M15 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V7L15 2ZM6 20V4H14L16 6L18 8V20H6Z" />
    <path d="M11 18H13V16H11V18ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z" />
  </>,
  'FileMissing',
)
